    // Map question text and survey question text should be translated within appConfig.js
    // Do not edit text within curly brackets, ie: {abc}
    // Format: "<ComponentName>.<Description>": "<Text>"

    module.exports = ({
        "polyline": "ផ្លូវ",
        "icon": "គ្រឿងសម្គាល់",
        "polygon": "ទ្រង់ទ្រាយ",

        // (optional) {branch_name} can be used to display the branch display name in the document title
        "DocumentTitle.map_page": "{branch_name} | ផែនទី",
        "DocumentTitle.error_page": "{branch_name} | កំហុស",
        "DocumentTitle.end_page": "{branch_name} | បញ្ចប់",
        "DocumentTitle.intro_modal": "{branch_name} | សេចក្តីផ្តើម",
        "DocumentTitle.info_modal": "{branch_name} | ព័ត៌មាន",
        "DocumentTitle.survey_modal": "{branch_name} | ការស្ទង់មតិ",

        "Landing.header": "សូមស្វាគមន៍!",
        "Landing.main_copy": "ប្រើឧបករណ៍នេះដើម្បីប្រាប់យើងពីរបៀបដែលអ្នកធ្វើការប្រាស្រ័យទាក់ទង​ជាមួយសហគមន៍របស់អ្នក និងជួយឲ្យយើង​យល់ពីការពិចារណា​សម្រាប់​ទីកន្លែងនេះ។",
        "Landing.back_to_map": "ត្រឡប់ទៅផែនទី",
        "Landing.start_answering": "ចាប់ផ្តើម",
        "Landing.data.header": "ការប្រើប្រាស់ទិន្នន័យ",
        "Landing.data.copy": "យើងនឹងការពារឯកជនភាពរបស់អ្នក ហើយទិន្នន័យទាំងអស់​នឹងត្រូវបានប្រើលក្ខណៈផ្ទៃក្នុងប៉ុណ្ណោះ។",
        "Landing.help.header": "ការណែនាំ",
        "Landing.help.copy": "នៅលើផែនទីអ្នកអាចគូrចំណុច បន្ទាប់ ឬក្រឡាផ្ទៃ​ដើម្បី​ពណ៌នាអំពីទីកន្លែងរបស់អ្នក។ អ្នកអាចស្វែងរកទីកន្លែងមួយ ហើយ​ផែនទី​អាច​ត្រូវបាន​រំកិលមើល ពង្រីក និងបង្រួម និង​ផ្លាស់ប្តូរ​រវាង​ផែនទីផ្លូវ និង​ផ្កាយរណប។",
        "Landing.feedback": "ផ្ញើមតិត្រឡប់មកយើង",

        "MapContainer.continue": "បន្ត",
        "MapContainer.back_button": "ត្រលប់ទៅផែនទី",
        "MapContainer.info_button": "ការណែនាំ",
        "MapContainer.finish_button": "រួចរាល់ចប់សព្វគ្រប់ជាមួយផែនទី",
        "MapContainer.submit": "បញ្ជូន",
        "MapContainer.mapButtonInfo": "ពង្រីកទៅកាន់ទីតាំង",
        "MapContainer.roadmap": "ផែនទីផ្លូវ",
        "MapContainer.satellite": "ផ្កាយរណប",


        "CancelButton.text": "បោះបង់",

        "IconDrawer.expand_drawer": "ពង្រីក",
        "IconDrawer.instructions": "គូរ",

        "LayerToggle.roadmap": "ផែនទីផ្លូវ",
        "LayerToggle.satellite": "ផ្កាយរណប",

        "ConfirmationPopup.done": "រួចរាល់",
        "ConfirmationPopup.cancel": "បោះបង់",

        "PolygonDraw.default_message": "ចុចទីណាក៏បាន​ដើម្បីចាប់ផ្តើមគូសទ្រង់ទ្រាយរបស់អ្នក។",
        "PolygonDraw.alternative_message": "គូរចំណុចដើម្បីប្តូរទំហំទ្រង់ទ្រាយរបស់អ្នក។",

        "PolylineDraw.default_message": "ចុចទីណាក៏បានដើម្បីចាប់ផ្តើមគូរបន្ទាត់របស់អ្នក។",
        "PolylineDraw.alternative_message": "គូរចំណុចដើម្បីប្តូរទំហំទ្រង់ទ្រាយរបស់អ្នក។",

        "IconDrop.default_message": "ចុចទីណាក៏បានដើម្បីបន្ថែមរូបតំណាង។",
        "IconDrop.alternative_message": "ចុចអូសរូបតំណាងដើម្បីផ្លាស់ប្តូរទីតាំងរបស់វា។",

        "EditModal.delete": "លុប",
        "EditModal.save": "រក្សាទុក",
        "EditModal.cancel": "បោះបង់",
        "EditModal.textarea_placeholder": "ប្រាប់យើងថែមទៀត។ ឬចុចរក្សាទុក",
        "EditModal.addTitle": "បន្ថែម {icon_type} របស់អ្នក",
        "EditModal.editTitle": "កែសម្រួល {icon_type} របស់អ្នក",
        "EditModal.reactionTitle": "ប្រាប់យើងពីបទពិសោធន៍របស់អ្នក",
        "EditModal.starRatingTitle": "តើអ្នកវាយតម្លៃបទពិសោធន៍របស់អ្នកនៅទីនេះយ៉ាងដូចម្តេចដែរ?",
        "EditModal.commentTitle": "មានយោបល់អ្វីផ្សេងទៀតទេ?",
        "EditModal.deleteConfirmation": "តើអ្នកប្រាកដទេ?",
        "EditModal.deleteConfirmationText": "ការលុប {icon_type} នេះមិនអាចមិនធ្វើវិញបានទេ។",

        "SearchBox.placeholder": "ស្វែងរកទីតាំង",

        "Survey.submitting": "កំពុងបញ្ជូន...",

        "EndLanding.header": "សូមអរគុណ",
        "EndLanding.copy": "កំពុងបញ្ចប់ការចម្លង",
        "EndLanding.take_again": "ចែករំលែកការយល់ដឹងទូលំទូលាយថែមទៀត​អំពីទីកន្លែងរបស់អ្នក -- ចាប់ផ្តើមម្តងទៀត!",
    });



// WEBPACK FOOTER //
// ./src/locales/km-KM.js